module.exports = __webpack_public_path__ + "static/media/feature_flag_description_mobile.ad6425b4.png";